var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, Renderer2 } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AnimatedModalComponent } from '@app/shared/modals/animated-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import * as amplitude from 'amplitude-js';
import { BonusService } from '@app/core/bonus.service';
import { AlertService } from '@app/core/alert.service';
var DepositPromotionModalComponent = /** @class */ (function (_super) {
    __extends(DepositPromotionModalComponent, _super);
    function DepositPromotionModalComponent(ref, elRef, renderer, router, activatedRoute, http, bonusService, alertService) {
        var _this = _super.call(this, elRef, renderer) || this;
        _this.ref = ref;
        _this.elRef = elRef;
        _this.renderer = renderer;
        _this.router = router;
        _this.activatedRoute = activatedRoute;
        _this.http = http;
        _this.bonusService = bonusService;
        _this.alertService = alertService;
        _this._items = [];
        _this.loading = false;
        return _this;
    }
    DepositPromotionModalComponent.prototype.ngOnInit = function () {
        amplitude.getInstance().logEvent('Deposit - Promotion Modal');
        this.item = this._items[0];
    };
    DepositPromotionModalComponent.prototype.close = function () {
        this.ref.close(0);
    };
    DepositPromotionModalComponent.prototype.reject = function () {
        this.ref.dismiss(1);
    };
    DepositPromotionModalComponent.prototype.showTerms = function ($event) {
        var _this = this;
        $event.preventDefault();
        this.router.navigate(['/legal/bonus-terms', { outlets: { modal: null } }]).then(function () {
            _this.router.navigate(['/', { outlets: { modal: null } }]).then(function () {
                _this.reject();
            });
        });
    };
    DepositPromotionModalComponent.prototype.activate = function () {
        var _this = this;
        if (this.loading) {
            return;
        }
        this.loading = true;
        this.bonusService
            .activateBonus(this.item._id)
            .then(function () {
            _this.loading = false;
            _this.close();
        })
            .catch(function (e) {
            _this.loading = false;
            _this.alertService.error({ title: 'Error!', text: e.json().error });
        });
    };
    return DepositPromotionModalComponent;
}(AnimatedModalComponent));
export { DepositPromotionModalComponent };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/deposit-promotion-modal.component.ts.pre-build-optimizer.js